import { render } from "./App.vue?vue&type=template&id=c80cef44"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c80cef44&lang=scss"

import exportComponent from "D:\\建龙工作\\开发项目\\VUE程序包\\宿舍报修系统\\bxxt\\bxxt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__